"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimaryFeedIconType = void 0;
var PrimaryFeedIconType;
(function (PrimaryFeedIconType) {
    PrimaryFeedIconType["peerPhoto"] = "peerPhoto";
    PrimaryFeedIconType["generic"] = "generic";
    PrimaryFeedIconType["scoresUpdated"] = "scoresUpdated";
    PrimaryFeedIconType["premiumPlus"] = "premiumPlus";
    PrimaryFeedIconType["rewardLevelObtained"] = "rewardLevelObtained";
    PrimaryFeedIconType["dailyReflection"] = "dailyReflection";
    PrimaryFeedIconType["surveyLink"] = "surveyLink";
    PrimaryFeedIconType["peerAssessmentRewardLevelObtained"] = "peerAssessmentRewardLevelObtained";
    PrimaryFeedIconType["weeklyPublicProfileViews"] = "weeklyPublicProfileViews";
})(PrimaryFeedIconType = exports.PrimaryFeedIconType || (exports.PrimaryFeedIconType = {}));
